import React from "react";

const DashboardCountDetails = ({ totalRequests, statusType }) => {
  return (
    <div className="main-header">
      {/* <div className="header">JK admin</div> */}
      <nav className="header-nav">
        <li className="header-link sent">
          <h1>{totalRequests}</h1> Requests total
        </li>
        <li className="header-link viewed">
          <h1>{statusType.statusTypes.Read}</h1>Requests viewed
        </li>
        <li className="header-link approved">
          <h1>{statusType.statusTypes.Pending}</h1>Requests approved
        </li>
        <li className="header-link completed">
          <h1>{statusType.statusTypes.Completed}</h1> Requests completed
        </li>
      </nav>
    </div>
  );
};

export default DashboardCountDetails;
